import { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "@/App.css";

import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";
import { useScrollReveal } from "@/lib/shared";

import HomePage from "@/pages/HomePage";
import ConnectPage from "@/pages/ConnectPage";
import VoiceAIPage from "@/pages/VoiceAIPage";
import InsightsPage from "@/pages/InsightsPage";
import MeetingAIPage from "@/pages/MeetingAIPage";
import DeviceManagerPage from "@/pages/DeviceManagerPage";
import ContactCenterPage from "@/pages/ContactCenterPage";

const PRODUCT_ROUTES = [
  "/connect",
  "/voice-ai",
  "/insights",
  "/meeting-ai",
  "/device-manager",
  "/contact-center",
];

const ScrollToTopOnRouteChange = () => {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }
  }, [location.pathname, location.hash]);
  return null;
};

const Shell = () => {
  const location = useLocation();
  useScrollReveal(location.pathname);
  const showBackToHome = PRODUCT_ROUTES.includes(location.pathname);

  return (
    <div className="cn-root" data-testid="app-root">
      <Nav showBackToHome={showBackToHome} />
      <ScrollToTopOnRouteChange />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/connect" element={<ConnectPage />} />
          <Route path="/voice-ai" element={<VoiceAIPage />} />
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/meeting-ai" element={<MeetingAIPage />} />
          <Route path="/device-manager" element={<DeviceManagerPage />} />
          <Route path="/contact-center" element={<ContactCenterPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}

export default App;
